import { render, staticRenderFns } from "./TabelaPrecoItens.vue?vue&type=template&id=26f96688"
import script from "./TabelaPrecoItens.vue?vue&type=script&lang=js"
export * from "./TabelaPrecoItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports